function StateChange($rootScope, $state, jsSdkAuthService, tlAuthService, modalService, $timeout, $window, iframeService, $location, fraudService, metaTagService, partnerService) {
  partnerService.init(); //TODO: TIM move this

  let appInitialized = false;

  $rootScope.$on('$stateChangeStart', () => {
    modalService.dismissAll();
  });

  $rootScope.$on('$stateChangeSuccess', (fromState, toState) => {
    if (!fromState) return;

    if (toState.scrollToTop === false) {
      return;
    }

    $timeout(function() {
      $window.scrollTo(0, 0);
    }, 100);

    iframeService.postMessage({
      eventType: 'routeChange',
      url: $location.absUrl()
    });

    fraudService.trackPageView();
  });

  $rootScope.$on('unauthorized', () => {
    jsSdkAuthService.logout();
    tlAuthService.logout();

    $state.go('app.login');
  });

  $rootScope.$on('$viewContentLoaded', () => {
    $timeout(() => {
      iframeService.postMessage({
        eventType: 'metaChange',
        title: metaTagService.getKey('title'),
        description: metaTagService.getKey('description'),
        facebookTitle: metaTagService.getKey('facebookTitle'),
        facebookDescription: metaTagService.getKey('facebookDescription'),
        deeplink: metaTagService.getKey('deeplink')
      });
    });
  });

  $rootScope.$on('$locationChangeStart', () => {
    //NOTE: make sure the code below only gets run right when the app loads.
    //if a partner is configured via subdomain or query string we can redirect them before the app loads
    if (appInitialized) return;

    appInitialized = true;

    const partner = partnerService.partner;

    if (partner && partner.path && partner.path !== $location.path() && $location.path() !== '/404') {
      $location.path(partner.path);
    }
  });
}

StateChange.$inject = [
  '$rootScope',
  '$state',
  'jsSdk.auth',
  'tl.auth.service',
  'modalService',
  '$timeout',
  '$window',
  'iframeService',
  '$location',
  'fraudService',
  'metaTagService',
  'partnerService'
];

export default StateChange;



// WEBPACK FOOTER //
// ./src/stateChange.js